import { Box, Divider, Grid, GridItem, Spinner, Text } from "@chakra-ui/react";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import CheckSuccessAnimationData from "../../../assets/animations/checkSuccessAnimation.json";
import BlockAnimationData from "../../../assets/animations/blockAnimation.json";
import CheckErrorAnimatonData from "../../../assets/animations/checkErrorAnimation.json";
import { getVerifiedSteps } from "../../../Pages/traceability/Pages/api";

const Verification = ({ id, refetchLastVerifiedAt }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [showResultBox, setShowResultBox] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [verificationSteps, setVerificationSteps] = useState({ integrityCheckPassed: null, steps: [] })
  const { integrityCheckPassed, steps } = verificationSteps

  const isLastElement = (index) => index === steps.length - 1;
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const triggerCheckAnimation = async (steps, i = 0) => {
    if (i < steps.length) {
      await sleep(Math.floor(Math.random() * (3000 - 1500 + 1)) + 1500)
      const updatedSteps = [...steps];
      updatedSteps[i].isLoading = false;
      setVerificationSteps((prevData) => ({ ...prevData, steps: updatedSteps }));
      await triggerCheckAnimation(steps, i + 1);
    } else {
      await sleep(1000);
      setErrorMessage(steps.find((e) => !e?.status)?.message || '');
      setShowResultBox(true);
    }
  }

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      setShowResultBox(false)

      const res = await getVerifiedSteps(id)
      setVerificationSteps(res.data)
      refetchLastVerifiedAt()

      setIsLoading(false)
      triggerCheckAnimation(res.data.steps);
    })();

    return () => {
      setIsLoading(false);
      setShowResultBox(false);
      setVerificationSteps({ integrityCheckPassed: null, steps: [] });
      setErrorMessage('');
    }
  }, [])

  return (
    <Box mt={'2rem'} >
      {isLoading ? (
        <Lottie style={{ height: '8rem' }} animationData={BlockAnimationData} />
      ) : (
        <>
          {steps?.map((e, index) => (
            <Grid
              key={index}
              templateAreas={`"icon text" "line text"`}
              gridTemplateRows="auto 1fr"
              gridTemplateColumns="5rem 1fr"
              ml={'-0.6rem'}
            >
              <>
                <GridItem area="icon" display="flex" justifyContent="center" >
                  {e?.isLoading ? (
                    <Lottie animationData={BlockAnimationData} />
                  ) : (
                    <Lottie
                      loop={0}
                      animationData={e?.status ? CheckSuccessAnimationData : CheckErrorAnimatonData}
                      style={{
                        width: `${e?.status ? '4rem' : '4.25rem'}`,
                        transform: `${!e?.status && 'translateY(-.2rem)'}`
                      }}
                    />
                  )}
                </GridItem>
                {!isLastElement(index) && (
                  <GridItem area="line" display="flex" justifyContent="center">
                    <Divider orientation="vertical" background="gray.300" width="5px" />
                  </GridItem>
                )}
                <GridItem
                  mt={'.6rem'}
                  mb={!isLastElement(index) ? '4rem' : '1.5rem'}
                  area="text"
                  display="flex"
                  alignItems="center"
                  minH={'2.5rem'}
                >
                  <Text fontSize="14px">{e?.isLoading ? e?.title : e?.message}</Text>
                </GridItem>
              </>
            </Grid>
          ))}
          {showResultBox && (
            <Box
              background={integrityCheckPassed ? '#75b975' : '#f05b5b'}
              border={`1px solid ${integrityCheckPassed ? '#1fc61f' : '#FF5C61'}`}
              width="100%"
              p="1rem"
              borderRadius="8px"
              textAlign="center"
              mt="2rem"
            >
              <Text color="white">
                {integrityCheckPassed ? 'Trace successfully verified' : "Trace verification failed: " + errorMessage}
              </Text>
            </Box>  
          )}
        </>
      )}
    </Box>
  );
};

export default Verification;
